import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, KorwilBadge, Progress, SectionTitle } from "@/components/Shared";

export default function Korwil() {
  const [items, setItems] = useState([]);
  const { setKorwilFilter } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    api.get("/korwil/summary").then(({ data }) => setItems(data.items)).catch(() => {});
  }, []);

  return (
    <div data-testid="page-korwil">
      <SectionTitle title="Korwil Monitoring" subtitle="Pemantauan terpisah 4 Koordinator Wilayah" />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {items.map((k) => (
          <Card key={k.korwil} className="p-4" data-testid={`korwil-detail-card-${k.korwil.toLowerCase()}`}>
            <div className="flex items-center justify-between">
              <KorwilBadge value={k.korwil} />
              <span className="font-mono-data text-xs text-slate-400">{k.progress}% selesai</span>
            </div>
            <div className="mt-1 text-[10px] uppercase tracking-wider text-slate-500">
              Korda {(k.korda || []).join(", ") || "-"}
            </div>
            <div className="mt-3 font-mono-data text-3xl font-semibold text-white">
              {k.total_unit.toLocaleString("id-ID")}
            </div>
            <div className="text-[11px] text-slate-500">unit instalasi</div>
            <Progress value={k.progress} className="mt-3" />
            <div className="mt-4 space-y-1.5 text-[11px]">
              {[
                ["Total Teknisi", k.total_teknisi, "text-slate-200"],
                ["Total Sekolah", k.total_sekolah, "text-slate-200"],
                ["Unit Ada Teknisi", k.unit_dengan_teknisi, "text-emerald-300"],
                ["Unit Tanpa Teknisi", k.unit_tanpa_teknisi, "text-red-300"],
                ["Selesai", k.selesai, "text-emerald-300"],
                ["Pending", k.pending, "text-amber-300"],
                ["BAPP Pending", k.bapp_pending, "text-blue-300"],
              ].map(([l, v, c]) => (
                <div key={l} className="flex items-center justify-between border-b border-slate-800/60 pb-1">
                  <span className="text-slate-500">{l}</span>
                  <span className={`font-mono-data ${c}`}>{v.toLocaleString("id-ID")}</span>
                </div>
              ))}
            </div>
            <button
              data-testid={`korwil-open-${k.korwil.toLowerCase()}`}
              onClick={() => {
                setKorwilFilter(k.korwil);
                nav("/unit");
              }}
              className="mt-4 flex w-full items-center justify-center gap-1.5 rounded bg-blue-600 px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-blue-700"
            >
              Lihat Detail Unit <ArrowRight className="h-3.5 w-3.5" />
            </button>
          </Card>
        ))}
      </div>
    </div>
  );
}
